import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../core/api/api";
import axiosInstance from "../core/interceptor/http-interceptor-config";

export const getManageQueries = createAsyncThunk(
  "knowledgebase/getManageQueries",
  async () => {
    return await axiosInstance.get(Api.knowledgebase_manage_query);
  }
);

export const saveQuery = createAsyncThunk(
  "knowledgebase/saveQuery",
  async (query: any) => {
    return await axiosInstance.post(Api.knowledgebase_manage_query, query);
  }
);

export const queryDetail = createAsyncThunk(
  "knowledgebase/queryDetail",
  async (query: any) => {
    return await axiosInstance.post(Api.knowledgebase_manage_query, query);
  }
);

export const searchQuery = createAsyncThunk(
  "knowledgebase/search_query",
  async (dataObj: any) => {
    return await axiosInstance.post(Api.search_query_knowledgebase+dataObj.param, dataObj?.data);
  }
);

export const getPlayQueryObject = () => {
  let newQueryObject: any = {
    queryId: "",
    label: "",
    value: "",
    key:"",
    data:[],
    description: "",
    query: ""
  };
  
  return newQueryObject;
};